module.exports = __webpack_public_path__ + "img/20190528162349411.5223d50c.png";